import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewRef,
} from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { UserProfile } from "../../core/model/user-profile";
import { PermissionSelectedDTO } from "../../core/model/permission-selected-dto";
import { PermissionService } from "../../core/service/permission.service";
import { UserProfileService } from "../../core/service/user-profile.service";
import { AssocierPermissionAuProfile } from "../../core/model/associer-permission-au-profile";

@Component({
  selector: "app-permission-by-profile",
  templateUrl: "./permission-by-profile.component.html",
  styleUrls: ["./permission-by-profile.component.scss"],
})
export class PermissionByProfileComponent implements OnInit, OnDestroy {
  profileId: string;
  userProfile: UserProfile;

  permissionSelectedDTOs: PermissionSelectedDTO[] = [];
  loading = true;

  private destroy$ = new Subject<void>();

  constructor(
    private _router: Router,
    private _permissionService: PermissionService,
    private _userProfileService: UserProfileService,
    private _activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    const initialId =
      this._activatedRoute.snapshot.params["profileId"] ||
      this._activatedRoute.snapshot.paramMap.get("profileId");
    if (initialId) {
      this.loadForProfile(initialId);
    }

    this._activatedRoute.params
      .pipe(takeUntil(this.destroy$))
      .subscribe((params: Params) => {
        const id = params["profileId"];
        if (id && id !== this.profileId) {
          this.loadForProfile(id);
        }
      });
  }

  private loadForProfile(profileId: string): void {
    this.profileId = profileId;
    this.getUserProfile(profileId);
    this.getPermissions(profileId);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getUserProfile(profileId) {
    this._userProfileService
      .getUserProfileById(profileId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.userProfile = data;
          this.safeDetectChanges();
        },
        (error) => {
          console.log(error);
        }
      );
  }

  getPermissions(profileId) {
    this.loading = true;
    this._permissionService
      .findSelectedPermissions(profileId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.permissionSelectedDTOs = (data || []).sort((a, b) =>
            a.code > b.code ? 1 : -1
          );
          this.loading = false;
          this.safeDetectChanges();
        },
        (error) => {
          console.log(error);
          this.permissionSelectedDTOs = [];
          this.loading = false;
          this.safeDetectChanges();
        }
      );
  }

  changeAfterChecked(values: any, permissionId) {
    var input = new AssocierPermissionAuProfile();
    input.permissionId = permissionId;
    input.profileId = this.profileId;
    input.selected = values.currentTarget.checked;
    this.associer(input);
  }

  associer(associerPermissionAuProfile: AssocierPermissionAuProfile) {
    this._permissionService
      .associer(associerPermissionAuProfile)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.getPermissions(this.profileId);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  cancel(): void {
    this.goToList();
  }

  private goToList(): void {
    this._router.navigateByUrl("/parametrage/user-profile");
  }

  private safeDetectChanges(): void {
    const view = this.cdr as ViewRef;
    if (view && !view.destroyed) {
      this.cdr.detectChanges();
    }
  }
}
